import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import IconButton from '@material-ui/core/IconButton';
import Icon from '@material-ui/core/Icon';
import green from '@material-ui/core/colors/green';
import amber from '@material-ui/core/colors/amber';


const variantIcon = {
  success: 'check_circle',
  warning: 'warning',
  error: 'error',
  information: 'info',
};

const styles = theme => ({
  success: {
    backgroundColor: green[600],
  },
  error: {
    backgroundColor: theme.palette.error.dark,
  },
  information: {
    backgroundColor: '#fff',
    color: '#000'
  },
  warning: {
    backgroundColor: amber[700],
  },
  icon: {
    fontSize: 20,
    opacity: 0.9,
    marginRight: theme.spacing.unit,
  },
  message: {
    display: 'flex',
    alignItems: 'center',
  },
});


class IOMessage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      message: null,
    }
    this.handleClose = this.handleClose.bind(this);
  }

  shouldComponentUpdate(nextProps) {
    if (!nextProps.message && this.props.message) {
      this.setState({message: this.props.message});
      return false;
    }

    return true;
  }

  handleClose = (event, reason) => this.props.onClose(event, reason);

  render() {
    let message = this.props.message || this.state.message;
    if (!message) return null;

    const { classes } = this.props;

    return (
      <Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        autoHideDuration={message.variant === 'success' ? 3000 : 6000}
        open={this.props.open}
        onClose={this.handleClose}
        onExited={this.props.onExited}
      >
              <SnackbarContent
                className={classes[message.variant]}
                aria-describedby="client-snackbar"
                message={
                  <span id="client-snackbar" className={classes.message}>
                    <Icon className={classes.icon}> {variantIcon[message.variant]} </Icon>
                    {message.text}
                  </span>
                }
                action={[
                  <IconButton
                    key="close"
                    aria-label="Close"
                    color="inherit"
                    onClick={this.handleClose}
                  >
                    <Icon> close </Icon>
                  </IconButton>,
                ]}
              />
      </Snackbar>
    );
  }
}

IOMessage.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(IOMessage);



// WEBPACK FOOTER //
// ./src/components/modules/io/Message.js